import React from 'react'
import PropTypes from 'prop-types'

// Components
import WidgetListItem from './WidgetListItem'

// Presentational Component
const WidgetList = ({ widgets }) => {
	const listItems = widgets.map(widget => (
		<WidgetListItem key={widget.name} widgetName={widget.name} categoryName={widget.category} />
	))
	return <ul className="widget-list list-unstyled">{listItems}</ul>
}

WidgetList.propTypes = {
	widgets: PropTypes.array.isRequired,
}

export default WidgetList



// WEBPACK FOOTER //
// ./src/components/widgets/WidgetList.js